// -------------------------------------------------------------------------------------------
// The goal of this file is to allow asynchronous importing of DevExpress components.
// If you import all classes directly in your components, DevExpress will be included in your bundle.
// But DevExpress components are huge (~600KB gzipped), so we want to load them asynchronously.
// -------------------------------------------------------------------------------------------
// HOW TO USE:
// 1. import DevExpress components ONLY from this file (never from '@devexpress' directly)
// 2. For components use `<DXRG.component_name />` (e.g. `<DXRG.Button />`), for instantiation use use `new DXRG.class_name()`

import type {
  AsyncExportApproach,
  DxReportViewer,
} from 'devexpress-reporting/dx-webdocumentviewer';
import type { createViewModelGenerator } from '@devexpress/analytics-core/analytics-serializer-native';
import type {
  ReportViewModel,
  ExtensionModel,
  NavigateTab,
} from 'devexpress-reporting/dx-reportdesigner';
import type DxReportDesigner from 'devexpress-reporting/dx-reportdesigner';

export type {
  ReportViewModel,
  AsyncExportApproach,
  DxReportViewer,
  createViewModelGenerator,
  ExtensionModel,
  NavigateTab,
};

export let DXREP: {
  createViewModelGenerator: typeof createViewModelGenerator;
  AsyncExportApproach: typeof AsyncExportApproach;
  DxReportViewer: typeof DxReportViewer;
  DxReportDesigner: typeof DxReportDesigner;
} = {} as any;
let _promise: Promise<any> | null;
let _isLoaded: boolean;
let _error: any;

export function useReactReporting() {
  if (!_isLoaded) {
    if (!_promise) {
      _promise = initReporting();
    }
    // will trigger Suspense
    throw _promise;
  }
  if (_error) {
    throw _error;
  }
}

function initReporting() {
  return Promise.all([
    import('devexpress-reporting/dx-webdocumentviewer').then((x) => {
      DXREP = { ...(x as any), ...DXREP };
    }),

    import('@devexpress/analytics-core/analytics-serializer-native').then(
      (x) => {
        DXREP = {
          ...DXREP,
          createViewModelGenerator: x.createViewModelGenerator,
        };
      },
    ),
    import('devexpress-reporting/dx-reportdesigner').then((x) => {
      DXREP = {
        ...DXREP,
        DxReportDesigner: x,
      };
    }),
  ])
    .finally(() => {
      _isLoaded = true;
    })
    .catch((e) => (_error = e));
}
